import React from 'react';
import { TabbedForm, useRecordContext, useResourceContext } from 'react-admin';

import { ModuleAdditionalInfoInputTab } from './Tabs/ModuleAdditionalInfoTabs';
import { ModuleInformationInputTab } from './Tabs/ModuleInformationTabs';
import { LearningAndTeachingTabsInputTab } from './Tabs/LearningAndTeachingTabs';
import { useAzureADGroups } from '../../msal/useAzureADGroups';
import { ReadOnlyContext } from '../../lib/context/ReadOnlyContext';
import { EditToolbar } from '../../layout/EditToolbar';
import { ModuleAssessmentsInputTab } from './Tabs/ModuleAssessments';

const ModuleInputs = (props) => {
    const { canEditCourseAndModule, isSuperAdmin } = useAzureADGroups();
    const record = useRecordContext();
    const resource = useResourceContext();
    if (record) {
        record.versioningType = null;
    }

    const canEdit = isSuperAdmin || (resource === 'Module' && canEditCourseAndModule);

    return (
        <ReadOnlyContext.Provider value={!canEdit}>
            <TabbedForm
                {...props}
                defaultValues={props.defaultValues}
                toolbar={<EditToolbar />}
            >
                
            <ModuleInformationInputTab {...props} />
            <LearningAndTeachingTabsInputTab {...props} />
            <ModuleAssessmentsInputTab {...props} />
            <ModuleAdditionalInfoInputTab {...props} />
            
        </TabbedForm>
        </ReadOnlyContext.Provider>
    );
};

export default ModuleInputs;
